import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../component/layouts/dashboard/dashboard.component';
import { AuthGuard } from '../shared/auth.guard';
import { PermissionGuard } from '../shared/permission.guard';
import { TrailerListComponent } from './trailer-list/trailer-list.component';
import { TrailerAddComponent } from './trailer-add/trailer-add.component';
import { TrailerEditComponent } from './trailer-edit/trailer-edit.component';

const routes: Routes = [{
  path: 'trailer',
  component: DashboardComponent,
  canActivate: [AuthGuard, PermissionGuard],
  children: [{
    path: 'list',
    component: TrailerListComponent,
    data: { module: 'Remolque', accion: 'Listado de Remolques', type: 'list' }
  }, {
    path: 'add',
    component: TrailerAddComponent,
    data: { module: 'Remolque', accion: 'Creación de Remolque', type: 'add' }
  }, {
    path: 'update/:id',
    component: TrailerEditComponent,
    data: { module: 'Remolque', accion: 'Actualización de Remolque', type: 'update' }
  }]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrailerRoutingModule { }
